
export interface TemplateVariable {
    name: string;   // used as {{.Name}} in subject/body
    sample: string; // sample value for preview / test send
}

export const renderTemplate = (
    subject: string,
    htmlBody: string,
    variables: TemplateVariable[]
): { subject: string; html: string } => {
    let s = subject;
    let h = htmlBody;
    variables.forEach((v) => {
        const re = new RegExp(`\\{\\{\\.${v.name}\\}\\}`, "g");
        s = s.replace(re, v.sample || `[${v.name}]`);
        h = h.replace(re, v.sample || `[${v.name}]`);
    });
    return { subject: s, html: h };
};
